import { ArrowForwardIcon, IconSize } from '@ardoq/icons';
import { Text } from '@ardoq/typography';
import styled from 'styled-components';
import { DecoratorWrapper } from './atoms';

const DecoratorWrapperWithEllipsis = styled(DecoratorWrapper)`
  display: grid;
  grid-template-columns: auto 20px auto;
  column-gap: 8px;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  width: fit-content;
`;

type BasicReferenceDecoratorProps = {
  sourceComponentName: string;
  targetComponentName: string;
};

export const BasicReferenceDecorator = ({
  sourceComponentName,
  targetComponentName,
}: BasicReferenceDecoratorProps) => {
  return (
    <DecoratorWrapperWithEllipsis>
      <Text truncate="only-ellipsis">{sourceComponentName}</Text>
      <ArrowForwardIcon iconSize={IconSize.MEDIUM} />
      <Text truncate="only-ellipsis">{targetComponentName}</Text>
    </DecoratorWrapperWithEllipsis>
  );
};
